import { render, staticRenderFns } from "./ShowNewPassDlg.vue?vue&type=template&id=551be74e&"
import script from "./ShowNewPassDlg.vue?vue&type=script&lang=js&"
export * from "./ShowNewPassDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports